<div class="header">
    <h3>Alert</h3>
    <i
       (click)="action(false)"
       class="close-icon icon-cross_16px"></i>
</div>
<div class="content-modal">
    <span>{{ text }}</span>
</div>
<div class="controls">
    <button
            appTrackClickButton
            type="button"
            class="button primary"
            (click)="action(false)">{{ buttonsTitle.dismiss }}</button>
    
    <button 
        (click)="submit()" 
        appTrackClickButton 
        id="dismiss" 
        type="button" 
        class="button primary" 
        >{{ buttonsTitle.confirm }}
    </button>
</div>

